import UploadAttachment from "../../../../Components/AdminConsole/common/uploadAttachments";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import {open} from "../../../../modules/modals";
import {GLOBAL_MODALS} from "../../../../constant";

const mapStateToProps = state => {
    return {	
    };
};

const mapDispatchToProps = dispatch => {
    return {
	openShowDocsModal: (data={}) => dispatch(open(GLOBAL_MODALS.SHOW_DOCS_MODAL, data))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadAttachment));
